module.exports = __webpack_public_path__ + "static/media/money_icon.2a880fc1.png";